/**
 * @generated SignedSource<<0bcd9e63b49942905b273551997a86a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FormMetadataStyleEnum = "ImageCenter" | "ImageLeft" | "NoImage";
export type FormMetadataTemplateEnum = "Basic" | "CompanyLong" | "CompanyShort" | "PasswordProtected" | "PasswordProtectedShort";
import { FragmentRefs } from "relay-runtime";
export type Header_ZnglyInfo_Desktop$data = {
  readonly znglyInfo: {
    readonly customSocialLinks: ReadonlyArray<{
      readonly name: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly dashboardLink: string | null | undefined;
    readonly headerButtons: ReadonlyArray<{
      readonly bgColor: string | null | undefined;
      readonly bgHvColor: string | null | undefined;
      readonly form: {
        readonly node: {
          readonly content: string | null | undefined;
          readonly id: string;
          readonly imageUrl: string | null | undefined;
          readonly marketingConsent: boolean | null | undefined;
          readonly metadata: {
            readonly cookieExpiration: string | null | undefined;
            readonly formStyle: FormMetadataStyleEnum | null | undefined;
            readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
            readonly submitSuccessText: string | null | undefined;
          } | null | undefined;
          readonly password: boolean | null | undefined;
          readonly schema: string | null | undefined;
          readonly title: string;
          readonly uiSchema: string | null | undefined;
        };
      } | null | undefined;
      readonly name: string | null | undefined;
      readonly textColor: string | null | undefined;
      readonly textHvColor: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly headerLogo: {
      readonly description: string | null | undefined;
      readonly mediaDetails: {
        readonly sizes: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly sourceUrl: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly mediaItemUrl: string | null | undefined;
      readonly mimeType: string | null | undefined;
    } | null | undefined;
    readonly headerLogoLink: string | null | undefined;
    readonly headerText: string | null | undefined;
    readonly headerTextConditions: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "Header_ZnglyInfo_Desktop";
};
export type Header_ZnglyInfo_Desktop$key = {
  readonly " $data"?: Header_ZnglyInfo_Desktop$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header_ZnglyInfo_Desktop">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_ZnglyInfo_Desktop",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ZnglyInfo_Znglyinfo",
      "kind": "LinkedField",
      "name": "znglyInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dashboardLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaItem",
          "kind": "LinkedField",
          "name": "headerLogo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mediaItemUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mimeType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MediaDetails",
              "kind": "LinkedField",
              "name": "mediaDetails",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MediaSize",
                  "kind": "LinkedField",
                  "name": "sizes",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceUrl",
                      "storageKey": null
                    },
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerTextConditions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerLogoLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ZnglyInfo_Znglyinfo_headerButtons",
          "kind": "LinkedField",
          "name": "headerButtons",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bgColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "textColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bgHvColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "textHvColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ZnglyInfo_Znglyinfo_headerButtonsToFormConnectionEdge",
              "kind": "LinkedField",
              "name": "form",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Form",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "schema",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "uiSchema",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormMetadata",
                      "kind": "LinkedField",
                      "name": "metadata",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formStyle",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "cookieExpiration",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "submitSuccessText",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "marketingConsent",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "password",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "imageUrl",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ZnglyInfo_Znglyinfo_customSocialLinks",
          "kind": "LinkedField",
          "name": "customSocialLinks",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ZnglyInfo",
  "abstractKey": null
};
})();

(node as any).hash = "b29454f3a805c9d59dd62e267b6968b8";

export default node;
